import {
	colours,
	desktopLMediaQuery,
	desktopMediaQuery,
	device,
	laptopMediaQuery,
	tabletMediaQuery,
} from "@helpers";
import type { IModuleTableFields } from "@types-contentful";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import styled from "styled-components";
import { getCountryFlag } from "@utils/countryUtils";

const Card = styled.div`
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12), 0 6px 24px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-bottom: 16px;

  margin: 64px 40px 76px 40px;

  ${tabletMediaQuery} {
    margin: 78px 64px 88px 64px;
  }

  ${laptopMediaQuery} {
    margin: 68px 165px 96px 165px;
  }

  ${desktopMediaQuery} {
    margin: 113px 241px 164px 241px;
  }

  ${desktopLMediaQuery} {
    margin: 113px 561px 164px 561px;
  }
`;

const Table = styled.div<{
	numberOfRowsMobile: number;
	numberOfRowsLaptop: number;
	length: number;
}>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(${(props) => props.numberOfRowsMobile}, auto);
  grid-auto-flow: column;
  margin-right: -1px;
  margin-bottom: -1px;

  p:nth-last-child(2) {
    display: none;
  }

  p:last-child {
    display: none;
  }

  ${tabletMediaQuery} {
    p:last-child {
      display: ${(props) => (props.length % 2 !== 0 ? "block" : "none")};
    }
  }

  @media (min-width: ${device.laptop}) {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(${(props) => props.numberOfRowsLaptop}, auto);

    p:nth-last-child(2) {
      display: ${(props) => (props.length % 3 === 1 ? "block" : "none")};
    }

    p:last-child {
      display: ${(props) => (props.length % 3 !== 0 ? "block" : "none")};
    }
  }
`;

const TableData = styled.p`
  min-width: 100%;
  flex: 1;
  background-color: ${colours.WHITE};
  border-right: 1px solid ${colours.PALE_PEACH};
  border-bottom: 1px solid ${colours.PALE_PEACH};
  padding: 10px 5%;

  ${tabletMediaQuery} {
    min-width: 50%;
    padding: 10px 4%;
  }

  @media (min-width: ${device.laptop}) {
    min-width: 33%;
    padding: 10px 3%;
  }
`;

const FlagWrapper = styled.span`
  display: inline-block;
  margin-right: 4px;
  vertical-align: text-top;
  line-height: 1;
  margin-top: 0.5px;
`;

const TableModule = ({ data, name }: IModuleTableFields) => {
	const isCountriesTable =
		name === "WEB -  Plan - Roaming - Countries Table" ||
		name === "WEB - plan - IDD - countries table";
	const numberOfRowsMobile = Math.ceil(data?.length / 2);
	const numberOfRowsLaptop = Math.ceil(data?.length / 4);
	return (
		<Card>
			<Table
				length={data?.length}
				numberOfRowsMobile={numberOfRowsMobile}
				numberOfRowsLaptop={numberOfRowsLaptop}
			>
				{data?.map((content) => {
					const flag = isCountriesTable ? getCountryFlag(content) : "";
					return (
						<TableData key={content}>
							{flag !== "" && (
								<FlagWrapper>
									<ReactCountryFlag countryCode={flag} svg alt=""/>
								</FlagWrapper>
							)}
							{content}
						</TableData>
					);
				})}
				<TableData key="empty-1" />
				<TableData key="empty-2" />
			</Table>
		</Card>
	);
};

export default TableModule;
